export const IContract = Object.freeze({
  code: "code",
  label: "label",
  id: "id",
  description: "description",
  isSelected: "isSelected",
});

export class ContractModel {
  constructor(data = {}) {
    this[IContract.code] = data[IContract.code];
    this[IContract.label] = data[IContract.label];
    this[IContract.id] = data[IContract.id];
    this[IContract.description] = data[IContract.description];
    // we want to default to true if isSelected is not provided
    this[IContract.isSelected] = data[IContract.isSelected] || true;
  }

  getCode() {
    return this[IContract.code];
  }

  getLabel() {
    return this[IContract.label];
  }

  getId() {
    return this[IContract.id];
  }

  getDescription() {
    return this[IContract.description];
  }

  isSelected() {
    return this[IContract.isSelected];
  }
  switchSelected() {
    this[IContract.isSelected] = !this[IContract.isSelected];
  }
}
